'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.errorService
 * @description
 * # error.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('errorService', function() {

    var service = {};
    var errorObj = {
      title: '',
      message: '',
      status: null
    };

    service.handleError = _handleError;

    function _handleError(error, status) {
      switch (error.status) {
        case 401:
          return _handleUnauthorised(error);
        case 403:
          return _handleForbidden(error);
        case 404:
          return _handleNotFound(error);
        case 400:
          return _handleBadRequest(error);
        case 500:
          return _handleServerError(error);
        default:
          return _handleUnknwown(error);
      }
    }

    function _handleUnauthorised(error) {
      errorObj.title = 'Login Failed or Expired';
      errorObj.message = error.data.error_description; //jshint ignore: line
      errorObj.status = 401;
      errorObj.tfaRequired = error.data.error === 'tfa_required';
      return errorObj;
    }

    function _handleForbidden(error) {
      errorObj.title = 'Access Denied';
      errorObj.message = 'You are not authorised to access the requested resource.';
      errorObj.status = 403;
      return errorObj;
    }

    function _handleNotFound(error) {
      errorObj.title = 'Not Found';
      errorObj.message = 'Resource not found. Are you sure it exists?';
      errorObj.status = 404;
      return errorObj;
    }

    function _handleBadRequest(error) {
      errorObj.message = _getErrorString(error.data);
      errorObj.title = 'Form invalid';
      errorObj.status = 400;
      return errorObj;
    }

    function _handleServerError(error) {
      errorObj.message = 'An error has occured. The Administrator has been notified';
      errorObj.title = 'Server Error';
      errorObj.status = 500;
      return errorObj;
    }

    function _handleUnknwown(error) {
      return _handleServerError(error);
    }

    function _getErrorString(error) {
      var message = '';

      if (error.error) {
        message = error.error_description; //jshint ignore: line
        return message;
      }

      angular.forEach(error, function(value, key) {
        message += `${value}\n`;
      });

      return message;
    }

    return service;
  });
